import {AppIdentifiers, IOpenAppData} from "@sparkware/uc-sdk-core";
import {ICasinofiedApplication, IAppCloseParams} from "../casinofied-application.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {OpenCashierOptions} from "../../../../../../common/interfaces/cashier.service.interface";
import {
    getCasinofiedCommonAppContextParams, getCasinofiedCommonUserInfo,
    getCasinofiedDeviceInfo,
    getCasinofiedGeoInfoParams
} from "../../../casinofied-helper-functions";

export class CustomerRelationsApplication implements ICasinofiedApplication {
    constructor(public readonly openAppData: IOpenAppData, private readonly services: IServiceFactoryExtended) {
    }
    async open(): Promise<void> {
        this.isLoading = true;

        try {
            const options: OpenCashierOptions = {};
            if(this.openAppData.launchInfo.appSpecificParameters?.SessionType) {
                options.sessionType = this.openAppData.launchInfo.appSpecificParameters.SessionType;
            }

            const geoInfo = await getCasinofiedGeoInfoParams(this.services);

            this.services.casinofiedAnalytics.appInitRequest({
                correlationID: this.openAppData.correlationID,
                applicationContext: {
                    appID: this.openAppData.appID,
                    launchInfo: this.openAppData.launchInfo,
                    ...getCasinofiedCommonAppContextParams(this.services),
                    productPackageToID: this.services.cashier.getProductPackage()
                },
                deviceInfo: getCasinofiedDeviceInfo(this.services),
                geoInfo: geoInfo,
                userInfo: {
                    ...getCasinofiedCommonUserInfo(this.services),
                    userMode: 'authenticated'
                },
                messageBrokerChannels: this.services.messageBroker.channels
            });
            const featureType = this.openAppData.launchInfo.appSpecificParameters?.featureType;
            switch (featureType) {
                case 1:
                    await this.services.externalLinks.openOldChat();
                    break;
                case 2:
                    await this.services.externalLinks.openContactUs();
                    break;
                case 3:
                    await this.services.externalLinks.openHelpPage();
                    break;
                default:
                    await this.services.externalLinks.openHelpPage();
                    this.services.logger.error(`App ${this.openAppData.launchInfo?.sourceAppID} sent wrong featureType paramenter ${featureType}`);
            }

        } finally {
            this.isLoading = false;
        }
    }

    isOpeningInNewWindow(): boolean {
        return true;
    }

    get appId(): AppIdentifiers {
        return AppIdentifiers.CustomerRelations;
    }
    isDisposed: boolean = false;

    isLoading: boolean = false;

    get isMinimized(): boolean {
        return false;
    }

    dispose(): void {
        this.isDisposed = true;
    }

    maximize(): void {
    }

    minimize(appData: any): void {
    }

    waitForAppToOpen(): Promise<void> {
        return Promise.resolve();
    }

    close(params: IAppCloseParams): void {
        // not used at the moment, implemented to respect the interface constraints
        // if needed, check implementation in casinofied-application-base
    }
}